export interface FormErrors {
  firstName?: string;
  lastName?: string;
  workEmail?: string;
  phoneNumber?: string;
  companyName?: string;
  title?: string;
  currentPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}

export const validateField = (field: string, value: string) => {
  if (!value || value.trim() === "") {
    return "This field is required";
  }
  return "";
};

export const validateCurrentPassword = (
  value: string,
  storedPassword: string
) => {
  if (!value || value.trim() === "") {
    return "This field is required";
  }
  return "";
};

export const formatPhoneNumber = (phone: string | undefined | null): string => {
  if (!phone) return "";
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, "");
  
  // Format as (XXX) XXX-XXXX for US numbers
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  // Format as +X (XXX) XXX-XXXX for international numbers starting with country code
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  
  // Return original if it doesn't match common patterns
  return phone;
};

export const validateForm = (
  formData: any,
  setErrors: (errors: FormErrors) => void
) => {
  const newErrors: FormErrors = {};
  newErrors.firstName = validateField("firstName", formData.firstName);
  newErrors.lastName = validateField("lastName", formData.lastName);
  newErrors.workEmail = validateField("workEmail", formData.workEmail);
  newErrors.phoneNumber = validateField("phoneNumber", formData.phoneNumber);
  newErrors.companyName = validateField("companyName", formData.companyName);
  newErrors.title = validateField("title", formData.title);
  const wantsPasswordChange = Boolean(
    (formData.newPassword && formData.newPassword.trim() !== "") ||
    (formData.confirmPassword && formData.confirmPassword.trim() !== "") ||
    (formData.currentPassword && formData.currentPassword.trim() !== "")
  );

  if (wantsPasswordChange) {
    // Only require fields; correctness of current password is validated server-side
    newErrors.currentPassword = !formData.currentPassword || formData.currentPassword.trim() === ""
      ? "This field is required"
      : "";

    newErrors.newPassword = !formData.newPassword || formData.newPassword.trim() === ""
      ? "This field is required"
      : "";

    if (!formData.confirmPassword || formData.confirmPassword.trim() === "") {
      newErrors.confirmPassword = "This field is required";
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    } else {
      newErrors.confirmPassword = "";
    }
  } else {
    newErrors.currentPassword = "";
    newErrors.newPassword = "";
    newErrors.confirmPassword = "";
  }
  setErrors(newErrors);
  return !Object.values(newErrors).some((error) => error !== "");
};
